export default function Excel_Syllabus() {
  return <div>Excel_Syllabus</div>;
}
